import React from 'react';
import { Button } from './ui/button';

const EffortSelector = ({ activity, effort, onEffortChange }) => {
  const efforts = [
    { 
      id: 'EASY', 
      label: 'Easy', 
      description: activity === 'run' ? 'Conversational pace' : 'Leisurely ride',
      color: 'bg-green-100 text-green-800 border-green-200'
    },
    { 
      id: 'MODERATE', 
      label: 'Moderate', 
      description: activity === 'run' ? 'Steady effort' : 'Brisk pace',
      color: 'bg-yellow-100 text-yellow-800 border-yellow-200'
    },
    { 
      id: 'HARD', 
      label: 'Hard', 
      description: activity === 'run' ? 'High intensity' : 'Fast training',
      color: 'bg-red-100 text-red-800 border-red-200'
    }
  ];

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
        Effort Level
      </label>
      <div className="flex gap-2 flex-wrap">
        {efforts.map((effortOption) => (
          <Button
            key={effortOption.id}
            variant={effort === effortOption.id ? "default" : "outline"}
            size="sm"
            onClick={() => onEffortChange(effortOption.id)}
            className="flex-1 min-w-0"
          >
            <div className="text-center">
              <div className="font-medium">{effortOption.label}</div>
              <div className="text-xs opacity-75">{effortOption.description}</div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default EffortSelector;